import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/live/message/newByte',
    owner: '/home',
    // authority: 'discussionAdd',
    component: Loadable({
      loader: () => import('./new'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/live/message/:id/modByte',
    owner: '/home',
    // authority: 'discussionEdit',
    component: Loadable({
      loader: () => import('./mod'),
      loading: () => <RouteLoading />
    })
  },
];